import { createSelector } from 'reselect';

const toastMessagesSelector = state => state.toastMessenger;

export const messagesSelector = createSelector(
  toastMessagesSelector,
  ({ messages }) => messages,
);
